<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>
import DevicePixelRatio from './util/devicePixelRatio';
export default {
  name: 'app',
  mounted() {
  new DevicePixelRatio().init();
  }
}
</script>

<style lang="scss">
  @import 'assets/css/index.scss';
  @import 'assets/css/style.css';
  #app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?9ba606e4